module.exports = __webpack_public_path__ + "id_1.66938f1fafcbfde4a5e525b2621658ab.svg";